import React from 'react';

export default function Card({ className, children }) {
  return <hot-card class={className}>{children}</hot-card>;
}
